/**
 * Name: Edit Playlist Main saga
 * Author: @Gaurav
 * Date: 21-07-2021
 */
import { put, takeLatest, call } from 'redux-saga/effects';
import ApiCaller from '../ApiCaller';

const callAPI = (payload, tagIds) => {
  let url = `/v1/admin/playlists?search=${payload}`;
  if (tagIds && tagIds.length > 0) {
    url += `&tags=${tagIds.join(',')}`;
  }
  return ApiCaller(url, 'GET');
};

export default function* watchRequest() {
  yield takeLatest('GET_ALL_PLAYLIST', function* performAction(action) {
    yield put({ type: 'GET_ALL_PLAYLIST_INITIATED' });
    try {
      const data = yield call(callAPI.bind(this, action.payload, action.tagIds));
      yield put({ type: 'GET_ALL_PLAYLIST_SUCCESS', payload: data });
    } catch (error) {
      yield put({ type: 'GET_ALL_PLAYLIST_FAILED', payload: error });
    }
  });
}

